const init = () => {
    const NUMBER_SLIDER_SELECTOR = '.history-slider__number-slider';
    const ARROWS_NUMBER_SLIDER_SELECTOR = '.history-slider__number-arrows';
    const CONTENT_SLIDER_SELECTOR = '.history-slider__content';

    const $number = $(NUMBER_SLIDER_SELECTOR);
    const $content = $(CONTENT_SLIDER_SELECTOR);

    $number.slick({
        slidesToScroll: 1,
        slidesToShow: 5,
        rows: 0,
        infinite: false,
        asNavFor: CONTENT_SLIDER_SELECTOR,
        appendArrows: ARROWS_NUMBER_SLIDER_SELECTOR,
        // centerMode: true,
        focusOnSelect: true,
        responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1
              }
            }
        ]
    })

    $content.slick({
        slidesToScroll: 1,
        slidesToShow: 1,
        rows: 0,
        arrows: false,
        infinite: false,
        variableWidth: true,
        focusOnSelect: true,
        asNavFor: NUMBER_SLIDER_SELECTOR,
    })


}

export default {
    init
}